import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button, Table, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import moment from "moment";
import { FaTimes } from 'react-icons/fa'
import { capitalizeFirstLetter } from "../../utils/Helper";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import Select from "react-select";


const AddMom = () => {
  const location = useLocation();
  const { row = {} } = location.state || {};
  const [chPartnerList, setChPartnerList] = useState();
  const [productName, setProductName] = useState([]);
  const [rmList, setRmList] = useState();
  const [load, setLoad] = useState(false);
  const [errors, setErrors] = useState({});
  const date = row?.date?.split?.("T")?.[0] || "";
  const [accomplishedWithId, setAccomplishedWithId] = useState([]);
  const [memberOptions, setMemberOptions] = useState([]);


  const [formData, setFormData] = useState({
    agenda: row?.agenda || "",
    channel_partner_id: row?.channel_partner_id || "",
    relationship_manager_id: row?.relationship_manager_id || "",
    product_id: row?.product_id || "",
    date: date,
    // start_time: "",
    // end_time: "",
    address: row?.address || "",
    description: "",
    action: EditorState.createEmpty(),
    attachment: [],
    next_followup_date: "",
    next_followup_time: "",
    accomplished_with_id: row?.accomplished_with_id || "",
  });
  const [attachmentName, setAttachmentName] = useState([]);
  const fileInputRef = useRef(null);
  const [expenses, setExpenses] = useState([{ title: "", price: "" }]);
  const [expenseErrors, setExpenseErrors] = useState([]);
  const navigate = useNavigate();
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = {
    "auth-token": authToken,
    authorization: accessToken,
    "content-type": "multipart/form-data",
  };
  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];

  const pastDate = new Date(today.getTime() - 72 * 60 * 60 * 1000); // 72 hours ago
  const formattedPastDate = pastDate.toISOString().split('T')[0];

  useEffect(() => {
    fetchAndProductName();
    if (row?.channel_partner_id) {
      fetchRm(row?.channel_partner_id);
    }
  }, [row?.channel_partner_id]);

  useEffect(() => {
    fetchMember();
  }, []);


  const fetchAndProductName = async () => {
    try {
      const [chPartner, productName] = await Promise.all([
        APIServices.get("/admin/channel_partner/short_list", headers),
        APIServices.get("/admin/product/list?offset=0&limit=1000&sort_by=name&status=Active", headers),
      ]);
      if (chPartner?.data?.list) setChPartnerList(chPartner?.data?.list || []);
      if (productName?.data?.list)
        setProductName(productName?.data?.list || []);
    } catch (error) {
      console.log("error", error);
      setChPartnerList([]);
      setProductName([]);
    }
  };

  const fetchRm = async (chPtId) => {
    try {
      const response = await APIServices.get(
        `/admin/relationship_manager/by_channel_partner/${chPtId}`,
        headers
      );
      if (response?.status === 200) {
        setRmList(response?.data?.list || []);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setRmList([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    setFormData((prev) => {
      const updatedFiles = prev.attachment.filter((_, idx) => idx !== indexToRemove);
      return { ...prev, attachment: updatedFiles };
    });

    setAttachmentName((prev) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "attachment" && files.length > 0) {
      const newFiles = Array.from(files);
      setFormData((prev) => {
        const existingFiles = prev.attachment || [];
        const updatedFiles = [...existingFiles, ...newFiles];

        return { ...prev, attachment: updatedFiles };
      });

      setAttachmentName((prev) => {
        const existingNames = prev || [];
        const newNames = newFiles.map((file) => file.name);
        return [...existingNames, ...newNames];
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (name === "channel_partner_id") {
      setFormData((pre) => ({ ...pre, relationship_manager_id: "" }));
      fetchRm(value);
    }

    if (name == "relationship_manager_id") {
      let selectedRM = rmList.filter((item) => item.id == value)
      setFormData((pre) => ({ ...pre, address: selectedRM[0].city_name }));
    }
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.agenda) newErrors.agenda = "Agenda is required.";

    if (!formData.channel_partner_id)
      newErrors.channel_partner_id = "Channel partner name is required.";

    if (!formData.relationship_manager_id)
      newErrors.relationship_manager_id = "Relationship manager is required.";

    if (!formData.product_id)
      newErrors.product_id = "Product Name is required.";

    // if (!formData.accomplished_with_id)
    //   newErrors.accomplished_with_id = "Accomplished with is required.";

    // if (!formData.description)
    //   newErrors.description = "Description is required.";

    if (!formData.address) newErrors.address = "Address is required.";

    if (!formData.date) newErrors.date = "Date is required.";

    // if (!formData.start_time) newErrors.start_time = "Start Time is required.";

    // if (!formData.end_time) newErrors.end_time = "End Time is required.";

    const contentState = formData.action.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    const hasText = rawContent.blocks.some((block) => block.text.trim() !== "");

    // if (!hasText) newErrors.action = "Action is required.";

    // if (!formData.attachment) newErrors.attachment = "Attachmente is required.";

    const hasDate = !!formData.next_followup_date;
    const hasTime = !!formData.next_followup_time;

    if ((hasDate && !hasTime)) {
      newErrors.next_followup_time = "Next Follow-Up Time is required if date is selected.";
    }
    if (!hasDate && hasTime) {
      newErrors.next_followup_date = "Next Follow-Up Date is required if time is selected.";
    }


    const errors = expenses.map((item) => {
      const itemErrors = {};

      if (item.title && !item.price) {
        itemErrors.price = ["Price is required."];
        newErrors.exp = "error "

      }

      if (item.price && !item.title) {
        itemErrors.title = ["Title is required."];
        newErrors.exp = "error "

      }

      return itemErrors;
    });

    setExpenseErrors(errors);

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoad(true);
      const rawContent = JSON.stringify(
        convertToRaw(formData.action.getCurrentContent())
      );
      const formDataToSubmit = new FormData();
      if (row?.id) {
        formDataToSubmit.append("parent_mom_id", Number(row?.id));
      }
      Object.keys(formData).forEach((key) => {
        if (key === "action") {
          formDataToSubmit.append(key, rawContent);
        } else if (key === "attachment" && Array.isArray(formData[key])) {
          formData[key].forEach((file) => {
            formDataToSubmit.append("attachment", file);
          });
        } else {
          formDataToSubmit.append(key, formData[key]);
        }
      });
      const validExpenses = expenses.filter(item => item.title && item.price);

      if (validExpenses.length > 0) {
        formDataToSubmit.append("expenses", JSON.stringify(validExpenses));
      }
      try {
        const response = await APIServices.post(
          `/admin/mom/add`,
          formDataToSubmit,
          headers
        );
        if (response?.data?.status === true) {
          showToast(response?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/mom-list");
          }, 2000);
        } else if (response?.status === 401) {
          logout();
          navigate("/");
        } else {
          showToast(
            response?.data?.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        showToast("Something went wrong.", "error");
      } finally {
        setLoad(false);
      }
    }
  };

  const handleEditorChange = (editorState) => {
    setFormData((prev) => ({
      ...prev,
      action: editorState,
    }));

    const contentState = editorState.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    const hasText = rawContent.blocks.some((block) => block.text.trim() !== "");
    if (hasText) {
      setErrors((prevErrors) => ({ ...prevErrors, action: "" }));
    }
  };

  const handleChangeExp = (index, field, value) => {
    const updated = [...expenses];
    updated[index][field] = value;
    setExpenses(updated);


    if (field === 'title') {
      const updatedErrors = [...expenseErrors];
      if (updatedErrors[index]?.title) {
        updatedErrors[index].title = undefined;
        setExpenseErrors(updatedErrors);
      }
    }
    if (field === 'price') {
      const updatedErrors = [...expenseErrors];
      if (updatedErrors[index]?.price) {
        updatedErrors[index].price = undefined;
        setExpenseErrors(updatedErrors);
      }
    }

  };

  const addExpense = () => {
    setExpenses([...expenses, { title: "", price: "" }]);
  };

  const removeExpense = (index) => {
    const updated = expenses.filter((_, i) => i !== index);
    setExpenses(updated);
  };
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const fetchMember = async () => {
    try {
      const response = await APIServices.get("/admin/member/accomplished_list", headers);
      const rawData = response?.data?.list || [];
      const formatted = transformForReactSelect(rawData);
      setMemberOptions(formatted);
    } catch (error) {
      console.error("Error fetching member data:", error);
    }
  };

  const handleFilterChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map((option) => option.value);
    setAccomplishedWithId(selectedOptions);
  };

  const transformForReactSelect = (rawData) => {
    return rawData.map((group) => {
      const groupName = Object.keys(group)[0];
      const members = group[groupName];
      return {
        label: groupName,
        options: members.map((member) => ({
          value: member.id,
          label: capitalizeFirstLetter(member.fullname),
        })),
      };
    });
  };

  return (
    <>
      <div className="addmom_inner">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">Add Minutes of Meeting</h1>
        </div>
        <Card className="mom_form">
          <Card.Body>
            <Form className="">
              <Form.Group className="mb-3">
                <Form.Label className="font_blue_14 font-500 mb-2 ">
                  Agenda
                </Form.Label>
                <Form.Control
                  type="text"
                  name="agenda"
                  value={formData.agenda}
                  onChange={handleChange}
                  placeholder="Enter agenda"
                />
                {errors.agenda && (
                  <div className="text-danger">{errors.agenda}</div>
                )}
              </Form.Group>

              <Row>
                <Col col={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Channel Partner Name
                    </Form.Label>
                    <Form.Select
                      name="channel_partner_id"
                      value={formData.channel_partner_id}
                      onChange={handleChange}
                    >
                      <option>Select Channel Partner Name</option>
                      {chPartnerList?.map((chpartner) => (
                        <option key={chpartner.id} value={chpartner.id}>
                          {capitalizeFirstLetter(chpartner.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.channel_partner_id && (
                      <div className="text-danger">
                        {errors.channel_partner_id}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col col={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Relationship Manager
                    </Form.Label>
                    <Form.Select
                      name="relationship_manager_id"
                      value={formData.relationship_manager_id}
                      onChange={handleChange}
                    >
                      <option>Select Relationship Manager</option>
                      {rmList?.map((rm) => (
                        <option key={rm.id} value={rm.id}>
                          {capitalizeFirstLetter(`${rm.first_name} ${rm.last_name}`)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.relationship_manager_id && (
                      <div className="text-danger">
                        {errors.relationship_manager_id}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col col={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Product Name
                    </Form.Label>
                    <Form.Select
                      name="product_id"
                      value={formData.product_id}
                      onChange={handleChange}
                    >
                      <option>Select Product Name</option>
                      {productName?.map((product) => (
                        <option key={product.id} value={product.id}>
                          {capitalizeFirstLetter(product.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.product_id && (
                      <div className="text-danger">{errors.product_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col col={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 d-block">
                      Date
                    </Form.Label>
                    <DatePicker
                      selected={formData.date}
                      onChange={(update) => {
                        console.log("update", update)
                        setFormData((prev) => ({
                          ...prev,
                          "date": update ? moment(update).format("YYYY-MM-DD") : null
                        }));
                      }}
                      maxDate={formattedToday}
                      // minDate={formattedPastDate}
                      placeholderText="dd/mm/yyyy"
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      wrapperClassName="w-100"
                    />
                  </Form.Group>
                  {errors.date && (
                    <div className="text-danger">{errors.date}</div>
                  )}
                </Col>
              </Row>
              {/* <Row>
                <Col col={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Meeting Duration
                    </Form.Label>
                    <Row>
                      <Col>
                        <Form.Control
                          type="time"
                          name="start_time"
                          value={formData.start_time}
                          onChange={handleChange}
                        />
                        {errors.start_time && (
                          <div className="text-danger">{errors.start_time}</div>
                        )}
                      </Col>
                      <Col>
                        <Form.Control
                          type="time"
                          name="end_time"
                          value={formData.end_time}
                          onChange={handleChange}
                        />
                        {errors.end_time && (
                          <div className="text-danger">{errors.end_time}</div>
                        )}
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
              </Row> */}

              <Form.Group className="mb-3">
                <Form.Label className="font_blue_14 font-500 mb-2 ">
                  Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Write here..."
                  style={{ height: "120px" }}
                />
                {errors.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="font_blue_14 font-500 mb-2 ">
                  Location
                </Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Enter address"
                />
                {errors.address && (
                  <div className="text-danger">{errors.address}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                {attachmentName && attachmentName.length > 0 && (
                  <ul className="mt-2 list-unstyled">
                    {attachmentName.map((name, index) => (
                      <li key={index} className="d-flex  align-items-center m-1 p-1 rounded" style={{ backgroundColor: '#F1F3F6', width: "fit-content" }}>
                        <span className="me-2">{name}</span>
                        <Button
                          variant=""
                          size="sm"
                          onClick={() => handleRemoveFile(index)}
                        >
                          <img
                            src="/images/cross.svg"
                            alt="trash"
                          />
                        </Button>
                      </li>
                    ))}
                  </ul>
                )}
                <Form.Control
                  type="file"
                  name="attachment"
                  className="d-none"
                  ref={fileInputRef}
                  onChange={handleChange}
                  id="fileInput"
                  multiple
                />
                <Button
                  variant="d-block"
                  className="att-btn"
                  onClick={() => fileInputRef.current?.click()}
                >
                  {attachmentName.length > 0 ? "+ Add More Attachment" : "+ Add Attachment"}
                </Button>
                {/* <p className="mt-2">
                  <strong>Uploaded File</strong>
                </p> */}
                {errors.attachment && (
                  <div className="text-danger">{errors.attachment}</div>
                )}
              </Form.Group>

              <Form.Group className="font_blue_14  mb-2">
                <Form.Label className="font-500">Add Expenses</Form.Label>

                {expenses.map((item, index) => (
                  <div key={index}>
                    <Row className="p-3 rounded mb-2" style={{ backgroundColor: '#F1F3F6' }}>
                      <Col md={6}>
                        <Form.Label>Expense Title</Form.Label>

                        <Form.Control
                          type="text"
                          placeholder=" Enter Expenses Title"
                          value={item.title}
                          onChange={(e) =>
                            handleChangeExp(index, "title", e.target.value)
                          }
                        />
                        {expenseErrors[index]?.title && expenseErrors[index].title.map((msg, i) => (
                          <div className="text-danger" key={i}>{msg}</div>
                        ))}
                      </Col>
                      <Col md={5}>
                        <Form.Label>Price</Form.Label>

                        <Form.Control
                          type="text"
                          placeholder="Enter Price"
                          value={item.price}
                          maxLength={8}
                          onChange={(e) =>
                            handleChangeExp(index, "price", e.target.value)
                          }
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                        {expenseErrors[index]?.price && expenseErrors[index].price.map((msg, i) => (
                          <div className="text-danger" key={i}>{msg}</div>
                        ))}

                      </Col>
                      <Col md={1} className="d-flex align-items-center justify-content-center">
                        {expenses.length > 1 && (
                          <FaTimes
                            size={20} // Adjust the size as needed
                            className="cursor-pointer"
                            onClick={() => removeExpense(index)}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                ))}
                <div className="text-end mb-3">
                  <Button
                    variant="success"
                    className="btn btn-sm border"
                    onClick={addExpense}
                  >
                    + Add More
                  </Button>
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className=" font-500 mb-2 ">
                  Action
                </Form.Label>
                <Editor
                  editorClassName="editor-container"
                  editorState={formData.action}
                  onEditorStateChange={handleEditorChange}
                  toolbar={{
                    options: ["inline", "list", "textAlign", "history"],
                    inline: { options: ["bold", "italic", "underline"] },
                    list: { options: ["unordered", "ordered"] },
                  }}
                />
                {errors.action && (
                  <div className="text-danger">{errors.action}</div>
                )}
              </Form.Group>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="font_blue_14 font-500 mb-2">
                    Accomplished With
                  </Form.Label>
                  <Form.Select
                    name="accomplished_with_id"
                    value={formData.accomplished_with_id}
                    onChange={handleChange}
                  >
                    <option value="">Select Accomplished With</option>
                    {memberOptions.map((group) => (
                      <optgroup
                        key={group.label}
                        label={capitalizeFirstLetter(group.label)}
                      >
                        {group.options.map((member) => (
                          <option key={member.value} value={member.value}>
                            {capitalizeFirstLetter(member.label)}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </Form.Select>
                  {errors.accomplished_with_id && (
                    <div className="text-danger">{errors.accomplished_with_id}</div>
                  )}
                </Form.Group>
              </Col>


              <Row>
                <Form.Label className="font-500">Next Follow-Up</Form.Label>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="next_followup_date"
                      value={formData.next_followup_date}
                      onChange={handleChange}
                    />
                    {errors.next_followup_date && (
                      <div className="text-danger">{errors.next_followup_date}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Time
                    </Form.Label>
                    <Form.Control
                      type="time"
                      name="next_followup_time"
                      value={formData.next_followup_time}
                      onChange={handleChange}
                    />
                    {errors.next_followup_time && (
                      <div className="text-danger">{errors.next_followup_time}</div>
                    )}
                  </Form.Group>
                </Col>


              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() => navigate("/admin/mom-list")}
                >
                  Cancel
                </Button>
                <Button
                  className="btn red_button"
                  onClick={handleSubmit}
                  disabled={load}
                >
                  {" "}
                  {load ? "Processing..." : "Save"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddMom;
